/* eslint-disable array-callback-return */
import { Discount } from '../../types/discounts';
import { DiscountWithStatus } from '../types';

export const getSortedDiscounts = (discounts: Discount[])  => {
    const activeDiscounts: Discount[] = [];
    const scheduledDiscounts: Discount[] = [];
    const completedDiscounts: Discount[] = [];
    const currentDate = new Date().getTime();

    discounts.map(discount => {
        const fromDate = new Date(discount.requirement.purchase_from).getTime();
        const toDate = new Date(discount.requirement.purchase_to).getTime();
        if (currentDate >= fromDate && currentDate <= toDate) {
            activeDiscounts.push(discount);
        } else if (currentDate < fromDate) {
            scheduledDiscounts.push(discount);
        } else if (currentDate > toDate) {
            completedDiscounts.push(discount);
        }
    });
    return { activeDiscounts, scheduledDiscounts, completedDiscounts };
};

export const addStatus = (discounts: Discount[]): DiscountWithStatus[]  => {
    const currentDate = new Date().getTime();

    return discounts
        .map(discount => {
            const fromDate = new Date(discount.requirement.purchase_from).getTime();
            const toDate = new Date(discount.requirement.purchase_to).getTime();
            if (discount.deleted_at && discount.deleted_by) {
                return {
                    ...discount,
                    status: 'deleted',
                };
            } else if (currentDate >= fromDate && currentDate <= toDate) {
                return {
                    ...discount,
                    status: 'active',
                };
            } else if (currentDate < fromDate) {
                return {
                    ...discount,
                    status: 'scheduled',
                };
            } else if (currentDate > toDate) {
                return {
                    ...discount,
                    status: 'completed',
                };
            } else {
                return discount;
            }
        });
};
